export type CounterpartySelectionMode = "NOT_USED" | "OPTIONAL" | "REQUIRED";

export default interface EsedoConfig {
  enabled: boolean;
  documentTypeId: string | null;
  documentType?: string | null;
  questionNatureId: string | null;
  questionNature?: string | null;
  counterpartySelectionMode: CounterpartySelectionMode;
}

export function defaultEsedoConfig(): EsedoConfig {
  return {
    enabled: false,
    documentTypeId: null,
    questionNatureId: null,
    counterpartySelectionMode: "NOT_USED",
  };
}
